/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';
import { render } from 'datocms-structured-text-to-html-string';

/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const Origin = ({ sectionContent, region, language }) => {
  const title = sectionContent.find(
    item => item._modelApiKey === 'section_title'
  )?.titleText;
  const titleSubText = sectionContent.find(
    item => item._modelApiKey === 'section_title'
  )?.titleSubtext;
  const singleLineTitle = sectionContent.find(
    item => item._modelApiKey === 'single_line_text'
  )?.text;
  const quoteDecoration = sectionContent.find(
    item => item._modelApiKey === 'quote'
  )?.quote;
  const decorationText = sectionContent.find(
    item => item._modelApiKey === 'structured_text'
  )?.body;

  return (
    <Box
      // padding={{ base: '13rem 7% 7rem', md: '16% ', lg: '20% 12%' }}
      padding={{
        base: '10rem 5% 7rem',
        md: '16% ',
        lg: '20% 12%',
        xl: '12% 12% 8%',
        '2xl': '7% 10% 7% 10%',
      }}
      // backgroundColor="#010509"
      position="relative"
      overflow={'hidden'}
    >
      <Box
        // width={{ base: '2.313rem', md: '100%' }}
        // height={{ base: '100%', md: '619px' }}
        width={{
          base: '46px',
          md: '5.313rem',
          lg: '100px',
          '2xl': '6.268125rem',
        }}
        height={{
          base: 'auto',
          md: '25rem',
          lg: '619px',
          '2xl': '38.6875rem',
        }}
        position="absolute"
        // top={{ base: '4rem', md: '-10rem', lg: '2%' }}
        top={{ base: '3%', md: '-10rem', lg: '2%', xl: '8%', '2xl': '6%' }}
        left={{
          base: '25%',
          md: '10rem',
          lg: '2rem',
          xl: '5%',
          '2xl': '20%',
        }}
        transform={{ base: 'rotate(270deg)', lg: 'rotate(360deg)' }}
      >
        <LazyLoadImageComponent
          width={'100%'}
          height={'100%'}
          src={`${config.imgPath}/d/46272/1718963233-colam-flowers-origin.png`}
          alt="flower image"
        />
      </Box>

      <Box
        textAlign="center"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        mt={{ base: '6rem', md: '' }}
        // border={"2px solid red"}
      >
        <Heading
          color="#FEFAF6"
          lineHeight={{ base: '1.8rem', md: '3.3rem' }}
          mb="1.5rem"
        >
          <Box
            as="span"
            fontWeight="400"
            lineHeight={{ base: '28.8px', md: '50.4px', '2xl': '52.8px' }}
            letterSpacing={'1%'}
            fontSize={{ md: '2.625rem', base: '1.5rem', '2xl': '2.75rem' }}
            fontFamily="var(--FedraSerifDisplay-Regular)"
          >
            {title}
          </Box>
          <Box
            as="span"
            color="#60ADFF"
            letterSpacing="1%"
            lineHeight={{ base: '28.8px', md: '52.8px' }}
            fontSize={{ base: '1.5rem', md: '2.75rem' }}
            fontFamily="var(--FedraSerifDisplay-Bold)"
          >
            {titleSubText}
          </Box>
        </Heading>
        <Text
          maxWidth="35.25rem"
          color="#F1EDE9"
          letterSpacing="2%"
          fontSize={{ base: '1.25rem', md: '1.5rem', '2xl': '1.75rem' }}
          lineHeight={{ base: '2rem', md: '2.4rem', '2xl': '2.8rem' }}
          fontWeight="400"
          fontFamily="var(--FedraSansStd-book)"
          textAlign="center"
          opacity={'70%'}
        >
          {singleLineTitle && singleLineTitle}
        </Text>
      </Box>

      <Box
        width={{ base: '100%', md: '90%', xl: '75%', '2xl': '45.25rem' }}
        textAlign="center"
        mx="auto"
        my="2rem"
        // border={"2px solid green"}
      >
        <Text
          color="#F1EDE9"
          fontSize={{ base: '1.125rem', md: '1.25rem' }}
          lineHeight={{ base: '1.8rem', md: '2rem' }}
          fontWeight="350"
          fontStyle="italic"
          fontFamily="var(--FedraSansStd-book)"
          letterSpacing="2%"
          textAlign="center"
        >
          {quoteDecoration}
        </Text>
      </Box>

      {decorationText && (
        <Box
          width={{ base: '100%', lg: '45.25rem' }}
          textAlign="center"
          mx="auto"
          css={{ '& p': { marginBottom: '2rem' } }}
        >
          <StructuredTextParser
            str={render(decorationText?.value)}
            region={region}
            lang={language}
            color="#F1EDE9"
            fontFamily="var(--FedraSansStd-book)"
            fontSize={{ base: '1rem', md: '1.125rem' }}
            lineHeight={{ base: '1.6rem', md: '1.8rem' }}
            fontWeight={350}
            letterSpacing="2%"
            textAlign="left"
            p="0"
          />
        </Box>
      )}

      <Box
        width={{ base: '3rem', md: '5.313rem', lg: '87px', '2xl': '93px' }}
        height={{
          base: '10rem',
          md: '25rem',
          lg: '30.688rem',
          '2xl': '38.6875rem',
        }}
        position="absolute"
        bottom={{ lg: 0, md: '-9rem', base: '0' }}
        right={{
          '2xl': '20%',
          xl: '5%',
          lg: '4rem',
          md: '10rem',
          base: '3rem',
        }}
        transform={{ base: 'rotate(92.22deg)', lg: 'rotate(180deg)' }}
      >
        <LazyLoadImageComponent
          width={{ '2xl': '100%' }}
          height={{ '2xl': '100%' }}
          src={`${config.imgPath}/d/46272/1718963233-colam-flowers-origin.png`}
          alt="flower image"
          transform={{ base: 'rotateY(180deg)', md: 'rotateY(35deg)' }}
        />
      </Box>
    </Box>
  );
};

export default Origin;
